<button (click)="goBack()" [shape]="'round'" nbButton>
    <nb-icon icon="arrow-ios-back-outline"></nb-icon>
</button>
